<div class="page background-pattern" fxLayout="column" fxLayoutAlign="center center">
  <div [@fadeInUp] class="card border-radius elevation">
    <div class="header padding background-primary" fxLayout="column" fxLayoutAlign="center center">
      <div class="logo fill-primary-contrast">
        <img src="assets/img/iconauth.png">
      </div>
    </div>
    <div class="padding" fxLayout="column" fxLayoutGap="16px" [formGroup]="form">
      <div fxFlex="auto" fxLayout="column">
        <mat-form-field fxFlex="grow">
          <mat-label>إسم المستخدم</mat-label>
          <input matInput required formControlName="email">
          <mat-error *ngIf="form.get('email').hasError('required')">أنت بحاجه لإسم المستخدم</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="grow">
          <mat-label>كلمة المرور</mat-label>
          <input matInput [type]="inputType" formControlName="password" required>
          <button type="button" mat-icon-button matSuffix (click)="toggleVisibility()" matTooltip="عرض كلمة المرور">
            <mat-icon *ngIf="visible">visibility</mat-icon>
            <mat-icon *ngIf="!visible">visibility_off</mat-icon>
          </button>
          <mat-hint>إضغط على العين لعرض كلمة المرور</mat-hint>
          <mat-error *ngIf="form.get('password').hasError('required')">أنت بحاجه لكلمة المرور</mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-checkbox class="caption">تذكرني</mat-checkbox>
        <a class="caption" [routerLink]="['/forgot-password']">نسيت كلمة المرور؟</a>
      </div>
      <button type="button" color="primary" mat-raised-button (click)="send()">
        تسجيل الدخول
      </button>
      <!-- <p class="secondary-text text-center">
        Don't have an account?<br/>
        <a [routerLink]="['/register']">Click here to create one</a>
      </p> -->
    </div>
  </div>
</div>
